<template>
    <div class="icon">
        <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect id="Rectangle" x="0" y="0" width="40" height="40"></rect>
            <g transform="translate(11.000000, 11.000000)" stroke="currentColor" stroke-linejoin="round">
            <polyline id="Path-7" stroke-width="1.5"
                        transform="translate(6.915882, 6.125768) scale(-1, 1) translate(-6.915882, -6.125768) "
                        points="0.945165409 2.22831394 7.68337904 10.0232217 12.8865996 7.43706176"></polyline>
            <line x1="8.11364215" y1="7.63031195" x2="8.11364215" y2="17.5892478" id="Path-8"
                    transform="translate(8.113642, 12.767819) scale(-1, 1) translate(-8.113642, -12.767819) "></line>
            <polyline id="Path-6" stroke-width="1.5" stroke-linecap="round"
                        transform="translate(7.747668, 8.794624) scale(-1, 1) translate(-7.747668, -8.794624) "
                        points="4.57411886e-13 5.04300711 2.47398354 2.25390322 9.26260873 -1.42108547e-14 15.4953369 6.97809255 14.1733157 7.63072138 14.1733157 13.4513599 7.57351196 17.5892478 1.07147088 16.2085868"></polyline>
            </g>
            <polyline id="Path-40" stroke="currentColor" stroke-linecap="round"
                    points="24 20.7829341 26.0945285 23 30 19"></polyline>
        </g>
        </svg>
    </div>
</template>
<script setup>
</script>